var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvedBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 12,
    viewBox: "0 0 25 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5288 5.76838L13.5407 6.51829L13.5407 6.51829L13.5288 5.76838ZM0.509589 5.44559C0.221403 5.74312 0.228974 6.21793 0.5265 6.50612L5.37496 11.2024C5.67249 11.4906 6.1473 11.483 6.43549 11.1855C6.72368 10.8879 6.7161 10.4131 6.41858 10.1249L2.10883 5.95049L6.28329 1.64074C6.57147 1.34321 6.5639 0.868401 6.26638 0.580214C5.96885 0.292028 5.49404 0.2996 5.20585 0.597126L0.509589 5.44559ZM13.5168 5.01848L1.03635 5.21749L1.06026 6.7173L13.5407 6.51829L13.5168 5.01848ZM19.5976 11.0017C19.5968 7.65928 16.8588 4.96519 13.5168 5.01848L13.5407 6.51829C16.0452 6.47835 18.097 8.49727 18.0976 11.002L19.5976 11.0017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedBackArrow);
export default __webpack_public_path__ + "static/media/curved_back_arrow.3b2c7b06b4baae52d482ab9c95ce3501.svg";
export { ForwardRef as ReactComponent };